<div class="row col-md-12" id="navigation_details" role="region" aria-label="Progress Information">
  <div class="col-md-11 text-left padding-right-0">
    <ul class="fl-r" aria-labelledby="navigation_details">
      @for (breadcrumb of breadcrumbs; track breadcrumb; let i = $index) {
        <div class="visuallyhidden" role="region" [attr.aria-label]="getBreadcrumbStatus(breadcrumb.isActive)"></div>
        @if (breadcrumb.enable) {
          <li [id]="'bcName_'+breadCrumb_toCamelCase(breadcrumb.name)" [ngClass]="{'first':i===0,'nav-label-active':breadcrumb.isActive,'margin-top-li':i>0}" class="nav-label">{{breadcrumb.name}}
          </li>
        }
      }
    </ul>
  </div>
  <div class="col-md-1 clear-all" id="navigation_links">
    <ul aria-labelledby="navigation_links">
      @for (breadcrumb of breadcrumbs; track breadcrumb; let i = $index) {
        @if (breadcrumb.enable) {
          <li [id]="'bcLine_'+breadCrumb_toCamelCase(breadcrumb.name)" [ngClass]="{'active':breadcrumb.isActive, 'multiline': breadcrumb.name.length > 20}" class="line"></li>
        }
      }
    </ul>
  </div>
</div>
